module.exports = __webpack_public_path__ + "img/collar buttons quantity.d1f89936.png";